export enum PanelType {
  ENTITIES_PANEL = 1,
  RESOURCES_PANEL = 2,
}

export enum EdrIncidentTabPanels {
  GRAPH,
  ALERTS,
  RESPONSE,
}

export enum XdrIncidentTabPanels {
  OVERVIEW,
  GRAPH,
  ALERTS,
  RESPONSE,
}

export enum IncidentType {
  XDR = 1,
  EDR = 2,
}

export enum IncidentTypeIcons {
  XDR = 'ds-icon-Organization_graph_XDR',
  EDR = 'ds-icon-Endpoint_graph_EDR',
}

export enum XdrNodesWithoutEventsPivoting {
  NODE_TYPE_AWS = 30,
  NODE_TYPE_AZURE = 31,
  NODE_TYPE_GCP = 32,
  NODE_TYPE_AD = 33,
  NODE_TYPE_OFFICE_365 = 34,
  NODE_TYPE_AZURE_AD = 35,
}
